import i18n from '@/i18n'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (reportTitle, data, vm) => {
    try {
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const pdfContent = []
      pdfContent.push({ text: reportTitle, style: 'header2', alignment: 'center', decoration: 'underline' })
      pdfContent.push({ text: '', style: 'fertilizer' })
      pdfContent.push({
        table: {
          headerRows: 1,
          body: [
            [
              { text: vm.$t('externalUser.profile_info_details'), style: 'th', bold: true, alignment: 'center' }
            ]
          ],
          widths: ['100%']
        }
      })
      const allRows = [
        [
          { text: vm.$t('production_service_config.reg_no'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: vm.$n(data.registration_id, { useGrouping: false }), style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('retailerManagement.email'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: data.email, style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('externalUser.org_name'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.org_name_bn : data.org_name), style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('externalUser.contact_person_name'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.contact_person_name_bn : data.contact_person_name), style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('retailerManagement.contact_no'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (i18n.locale === 'bn') ? '০' + vm.$n(data.contact_no, { useGrouping: false }) : '0' + vm.$n(data.contact_no, { useGrouping: false }), style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('retailerManagement.nid'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: data.nid_no, style: 'td', alignment: 'left' }
        ]
      ]
      const profile = []
      if (data.photo) {
        profile.push({ image: 'data:image/png;base64,' + data.photo, alignment: 'right', style: 'imageAlign', width: 120 })
      }
      pdfContent.push({
        table: {
          widths: ['30%', '70%'],
          body: [
            [
              {
                table: {
                  headerRows: 1,
                  widths: ['100%'],
                  body: [
                    [
                      profile
                    ]
                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return 0
                  },
                  vLineWidth: function (i, node) {
                    return 0
                  }
                }
              },
              {
                table: {
                  widths: ['40%', '5%', '55%'],
                  body: allRows
                },
                headerRows: 1,
                layout: {
                  hLineWidth: function (i, node) {
                    return 0
                  },
                  vLineWidth: function (i, node) {
                    return 0
                  }
                }
              }
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      })
      pdfContent.push({ text: '', style: 'fertilizer' })
      pdfContent.push({
        table: {
          headerRows: 1,
          body: [
            [
              { text: vm.$t('externalUser.organization_address'), style: 'th', bold: true, alignment: 'center' }
            ]
          ],
          widths: ['100%']
        }
      })
      const allRowsHead = [
        [
          { text: vm.$t('org_pro.area_type'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.area_name_bn : data.area_name), style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('org_pro_division.division'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.division_name_bn : data.division_name), style: 'td', alignment: 'left' }
        ],
        [
          { text: vm.$t('org_pro_district.district'), bold: true, style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.district_name_bn : data.district_name), style: 'td', alignment: 'left' }
        ]
      ]
      if (data.area_type_id === 2 || data.area_type_id === 3) {
        const rowItem = [
          { text: vm.$t('org_pro_upazilla.upazilla'), style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.upazilla_name_bn : data.upazilla_name), style: 'td', alignment: 'left' }
        ]
        allRowsHead.push(rowItem)
      }
      if (data.area_type_id === 3) {
        const rowItem = [
          { text: vm.$t('org_pro_union.union'), style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.union_name_bn : data.union_name), style: 'td', alignment: 'left' }
        ]
        allRowsHead.push(rowItem)
      }
      if (data.area_type_id === 1) {
        const rowItem = [
          { text: vm.$t('org_pro.city_corporation'), style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.cityCorporation_name_bn : data.cityCorporation_name), style: 'td', alignment: 'left' }
        ]
        allRowsHead.push(rowItem)
      }
      if (data.area_type_id === 2 || data.area_type_id === 3) {
        const rowItem = [
          { text: vm.$t('org_pro.ward'), style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.ward_name_bn : data.ward_name), style: 'td', alignment: 'left' }
        ]
        allRowsHead.push(rowItem)
      }
      if (data.area_type_id === 2) {
        const rowItem = [
          { text: vm.$t('org_pro.pauroshoba'), style: 'td', alignment: 'left' },
          { text: ':', style: 'td', alignment: 'center' },
          { text: (vm.$i18n.locale === 'bn' ? data.pauroshoba_name_bn : data.pauroshoba_name), style: 'td', alignment: 'left' }
        ]
        allRowsHead.push(rowItem)
      }
      const rowItem = [
        { text: vm.$t('globalTrans.address'), style: 'td', alignment: 'left' },
        { text: ':', style: 'td', alignment: 'center' },
        { text: (vm.$i18n.locale === 'bn' ? data.address_bn : data.address), style: 'td', alignment: 'left' }
      ]
      allRowsHead.push(rowItem)
      pdfContent.push({
        table: {
          headerRows: 1,
          body: allRowsHead,
          widths: ['25%', '5%', '65%']
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      })
      var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'potscape',
        styles: {
          header: {
            fontSize: 18,
            margin: [0, 0, 0, 4]
          },
          th: {
            fillColor: '#dee2e6',
            fontSize: 9,
            margin: [11, 5, 11, 5]
          },
          headerTitle: {
            fillColor: '#dee2e6',
            fontSize: 12,
            margin: [11, 5, 11, 5]
          },
          td: {
            fontSize: 9,
            margin: [11, 5, 11, 5]
          },
          fertilizer: {
            fontSize: 10,
            margin: [10, 10, 0, 20]
          },
          imageAlign: {
            fontSize: 10,
            margin: [10, 5, 5, 10]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          header1: {
            fontSize: 12,
            margin: [0, 0, 0, 2],
            border: 0
          }
        }
      }
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
}
export default {
  exportPdfDetails
}
